import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Backdrop,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Edit, Logout } from "@mui/icons-material";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";

import api from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { dynamicStatus } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardPageNumber,
  setReportPageNumber,
  setReportSearchValue,
  setSelectBoxInReport,
} from "../slice/searchPaginationSlice";

const ReportDetail = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  const [records, setAllRecords] = useState([]);
  const [dynamicHeader, setDynamicHeader] = useState([]);
  const [agencyReportId, setAgencyReportId] = useState(null);
  const [count, setCount] = useState(0);
  const [backDropLoading, setBackDropLoading] = useState(false);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordCopy, setSelectedRecordCopy] = useState(null);
  const { reportPageNumber, reportSearchValue, selectBoxInReport } =
    useSelector((store) => store.searchPagination);
  const [selectBox, setSelectBox] = useState(
    selectBoxInReport ? selectBoxInReport : ""
  );
  console.log(reportPageNumber, "reportPageNumber");
  const [formLoading, setFormLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState(
    reportSearchValue ? reportSearchValue : ""
  );
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  // const [page, setPage] = useState(0);

  const agencyRole = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))?.role
    : "";
  const fetchRecord = async (updatePage, search) => {
    try {
      // setLoading(true);
      setBackDropLoading(true);
      const response = await api.get(
        // `get_upload_studentData/?UploadStudentCSVInfo_id=${reportId}&search=${
        //   search ?? reportSearchValue
        // }&page=${updatePage ?? reportPageNumber + 1}`
        `upload-request/uploaded-file-list/${reportId}?limit=50&offset=${
          50 * (updatePage ?? reportPageNumber)
        }${
          search || searchQuery ? `&search_value=${search || searchQuery}` : ""
        }${
          (selectBox || dynamicHeader[0]) && (search || searchQuery)
            ? `&search_key=${selectBox || dynamicHeader[0]}`
            : ""
        }`
      );
      setAllRecords(response.data?.data?.data?.rows);
      setCount(response?.data?.data?.data?.count);
      setDynamicHeader(response?.data?.data?.columns);
      setAgencyReportId(response.data?.data?.data?.agency_id);
      if (!selectBox) {
        setSelectBox(response?.data?.data?.columns?.[0]);
      }
      if (!selectBoxInReport) {
        dispatch(setSelectBoxInReport(response?.data?.data?.columns?.[0]));
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data, please try again."
      );
      // navigate("/dashboard");
    } finally {
      setLoading(false);
      setBackDropLoading(false);
    }
  };
  useEffect(() => {
    if (!reportId) {
      navigate("/dashboard");
      return;
    }

    fetchRecord();
  }, [reportId]);
  let handler;

  useEffect(() => {
    return () => {
      clearTimeout(handler);
    };
  }, []);

  const handleSearch = (search) => {
    setSearchQuery(search);
    // setDebouncedQuery(search);
    dispatch(setReportSearchValue(search));

    /* handler = setTimeout(() => {
      fetchRecord(1, search);
 dispatch(setReportPageNumber(0));
      // setDebouncedQuery(search);
      dispatch(setReportSearchValue(search));

      dispatch(setReportPageNumber(0));
    }, 200);**/
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const handleEditClick = (record) => {
    setSelectedRecord(record);
    setOpenModal(true);
    setSelectedRecordCopy(record);
  };

  // const handleSave = async () => {
  //   const newName =
  //     selectedRecord?.newName?.trim() ?? selectedRecord?.name?.trim();
  //   const newSubjectName =
  //     selectedRecord?.newSubjectName?.trim() ??
  //     selectedRecord?.subjectName?.trim();
  //   const newMarks = selectedRecord?.newMarks ?? selectedRecord?.mark;

  //   if (agencyRole.toLowerCase() === "Agency1".toLowerCase()) {
  //     if (!newName || !newSubjectName || !newMarks) {
  //       toast.error("Please fill in all the required fields.");
  //       return;
  //     }
  //   } else if (agencyRole.toLowerCase() === "Agency2".toLowerCase()) {
  //     if (!newSubjectName || !newMarks) {
  //       toast.error("Please fill in all the required fields.");
  //       return;
  //     }
  //   }

  //   setFormLoading(true);
  //   try {
  //    const payload = {
  //       recordId: selectedRecord?.id,
  //       updateName:
  //         selectedRecord?.newName !== selectedRecord?.name
  //           ? selectedRecord?.newName
  //           : undefined,
  //       updateSubjectName:
  //         selectedRecord?.newSubjectName !== selectedRecord?.subjectName
  //           ? selectedRecord?.newSubjectName
  //           : undefined,
  //       updatedMarks:
  //         selectedRecord?.newMarks !== selectedRecord?.mark
  //           ? typeof selectedRecord?.newMarks === "string"
  //             ? parseInt(selectedRecord?.newMarks)
  //             : selectedRecord?.newMarks
  //           : undefined,
  //       recordUpdatedBy: getLocalStorage("user")
  //         ? JSON.parse(getLocalStorage("user")).id
  //         : undefined,
  //     };

  //     await api.post("edit_student_record/", payload);
  //     toast.success("Record updated successfully!");

  //     const response = await api.get(
  //       `get_upload_studentData/?UploadStudentCSVInfo_id=${reportId}`
  //     );
  //     setAllRecords(response?.data);

  //     setOpenModal(false);
  //     setSelectedRecord(null);
  //   } catch (error) {
  //     toast.error(
  //       error?.response?.data?.error ??
  //         "Error updating record, please try again."
  //     );
  //   } finally {
  //     setFormLoading(false);
  //   }
  // };

  const handleSave = async () => {
    let newErrors = {};
    dynamicHeader?.forEach((item) => {
      if (
        !selectedRecord?.[item?.toLowerCase()]?.trim() &&
        selectedRecordCopy?.[item?.toLowerCase()]
      ) {
        newErrors[
          item?.toLowerCase()
        ] = `Please fill ${item?.toUpperCase()} field.`;
      }
    });

    // Update errors state after loop
    setErrors((prev) => ({ ...prev, ...newErrors }));

    let updatedFields = {};
    let reqFields = {};

    dynamicHeader?.forEach((item) => {
      reqFields[item?.toLowerCase()] = selectedRecord?.[item?.toLowerCase()];
      if (
        selectedRecordCopy?.[item?.toLowerCase()]?.trim() !==
        selectedRecord?.[item?.toLowerCase()]?.trim()
      ) {
        updatedFields[item?.toLowerCase()] =
          selectedRecord?.[item?.toLowerCase()];
      }
    });

    console.log(updatedFields, newErrors, "updatedFields");

    if (!Object.keys(updatedFields).length) {
      toast.dismiss();
      toast.error("No fields are updated");
      return;
    }

    // Instead of checking errors directly, use newErrors
    if (Object.keys(newErrors).length) {
      return;
    }

    setFormLoading(true);

    try {
      const payload = {
        id: selectedRecord?.id,
        upload_id: selectedRecord?.upload_id,
        recordUpdatedBy: getLocalStorage("user")
          ? JSON.parse(getLocalStorage("user")).id
          : undefined,
        ...reqFields,
      };

      await api.patch("upload-request/record/", payload);
      toast.success("Record updated successfully!");

      setOpenModal(false);
      setSelectedRecord(null);
      fetchRecord();
    } catch (error) {
      toast.error(
        error?.response?.data?.error ??
          "Error updating record, please try again."
      );
    } finally {
      setFormLoading(false);
    }
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
    return `${day}-${month}-${year} ${time}`;
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setReportPageNumber(newPage));
    fetchRecord(newPage);
  };

  const handleView = (row) => {
    navigate(`/transaction?UploadId=${row?.upload_id}&Id=${row?.id}`);
  };
  const searchRecord = () => {
    dispatch(setReportPageNumber(0));
    fetchRecord(0, searchQuery);
  };

  const handleChangeSelectBox = (data) => {
    setSelectBox(data?.target?.value);
    dispatch(setSelectBoxInReport(data?.target?.value));
  };
  ////console.log()
  return (
    <>
      {/* Image Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {/* Header */}
        <Box
          display="flex"
          flexWrap="wrap"
          gap="10px"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
            }}
          >
            Report Details
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <FormControl
              size="small"
              style={{
                width: "150px",
              }}
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">Search By</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectBox}
                label="Search By"
                onChange={handleChangeSelectBox}
                style={{
                  width: "150px",
                }}
              >
                {dynamicHeader?.map((item) => {
                  return (
                    item !== "position" && (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    )
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              id="standard-basic"
              label="Search"
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setSearchQuery("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(setReportPageNumber(0));

                dispatch(setReportSearchValue(""));
                if (agencyReportId) {
                  navigate(`/reports/${agencyReportId}`);
                } else {
                  navigate(-1);
                }
              }}
              style={{ textTransform: "none" }}
            >
              Back to Report
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        {/* Table */}
        <TableContainer
          // sx={{ maxHeight: "57vh", overflow: "auto" }}
          component={Paper}
          style={{ marginTop: "32px" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
                {/* <TableCell align="center">
                  <strong>Roll Number</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Subject</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Marks</strong>
                </TableCell> */}
                {dynamicHeader?.map((item) => {
                  return (
                    item !== "position" && (
                      <TableCell align="center">
                        <strong>{item ? item?.toUpperCase() : "_"}</strong>
                      </TableCell>
                    )
                  );
                })}
                {/* <TableCell align="center">
                  <strong>No. of Approvals</strong>
                </TableCell> */}
                <TableCell align="center">
                  <strong>Status</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>Uploaded By</strong>
                </TableCell> */}
                <TableCell align="center">
                  <strong>Updated At</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>Transaction Id</strong>
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    background: "white", // Ensures it stays visible
                    zIndex: 2, // Ensures it stays above other columns
                  }}
                >
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {records.length > 0 ? (
                records.map((row) => (
                  <TableRow
                    key={row?.id}
                    style={{ textWrap: "nowrap", textAlign: "center" }}
                  >
                    {/* <TableCell align="center">
                      {row?.rollNumber ? row?.rollNumber : "-"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.subjectName ? row?.subjectName : "-"}
                    </TableCell>
                    <TableCell align="center">
                      {row?.mark ? row?.mark : "-"}
                    </TableCell> */}
                    {dynamicHeader?.map((item) => {
                      return (
                        item !== "position" && (
                          <TableCell
                            align="center"
                            style={{
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {row?.[item?.toLowerCase()]
                              ? row?.[item?.toLowerCase()]
                              : "-"}
                          </TableCell>
                        )
                      );
                    })}
                    {/* <TableCell align="center">
                      {row?.updatedRecords && row?.updatedRecords.length
                        ? (row?.updatedRecords[0]?.noOfApproval ?? "0") + "/3"
                        : "-"}
                    </TableCell> */}
                    <TableCell align="center">
                      {row?.updatedRecords && row?.updatedRecords.length ? (
                        <Chip
                          label={row?.updatedRecords[0]?.recordStatus}
                          color={dynamicStatus(
                            row?.updatedRecords[0]?.recordStatus
                          )}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    {/* <TableCell align="center">
                      {row?.uploadedBy
                        ? `${row?.uploadedBy?.whichUser?.first_name ?? ""} ${
                            row?.uploadedBy?.whichUser?.last_name ?? ""
                          }`
                        : "-"}
                    </TableCell> */}
                    <TableCell align="center">
                      {row?.createdAt ? formatCustomDate(row?.createdAt) : "-"}
                    </TableCell>
                    {/* <TableCell align="center">
                      {row?.transactionId ? row?.transactionId : "-"}
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        background: "white", // Ensures it stays visible
                        zIndex: 2, // Ensures it stays above other columns
                      }}
                    >
                      {" "}
                      <Button
                        variant="text"
                        style={{
                          color: "white",
                          // borderColor: "#8C0001",
                          textTransform: "none",
                          backgroundColor: "#8C0001",
                        }}
                        onClick={() => handleView(row)}
                      >
                        View
                      </Button>
                      {/* <Button
                        startIcon={<Edit />}
                        variant="text"
                        style={{
                          color: "#8C0001",
                          borderColor: "#8C0001",

                          cursor: editButtonDisable(row)
                            ? "not-allowed"
                            : "pointer",
                        }}
                        onClick={() => {
                          !editButtonDisable(row) && handleEditClick(row);
                        }}
                        // disabled={editButtonDisable(row)}
                      >
                        Edit
                      </Button> */}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={dynamicHeader?.length + 4} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={reportPageNumber}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}–${to} of ${count.toLocaleString("en-IN")}`
          }
        />
      </Container>
      <Backdrop open={backDropLoading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ReportDetail;
